import { getRawCookie, setRawCookie, removeCookie } from 'tiny-cookie'
import axios from 'axios'
import {fromApiAddressFormat, toApiAddressFormat} from "./mungeAddress";

const JWT_COOKIE = 'jwtToken';
const JWT_COOKIE_OPTS = {}; // TODO choose opts... mimic current app?
var jwtToken, pending, currentUser;

export function setAuthState({token, user}) {
  jwtToken = token;
  currentUser = fromApiAddressFormat(user);
  if (jwtToken) {
    setRawCookie(JWT_COOKIE, jwtToken, JWT_COOKIE_OPTS);
  } else {
    removeCookie(JWT_COOKIE, JWT_COOKIE_OPTS);
  }
  return currentUser;
}

/**
 * Kick off authorization process. Should be called before any services.
 */
export function authorize() {
  if (jwtToken) return;
  pending = requestToken(getRawCookie(JWT_COOKIE));
}

/**
 * Return whether user is anonymous or real (but without verifying with server).
 * If there is no established user, return true (ie, assume anonymous). This
 * function can be called upon page load.
 */
export function isAnonymous() {
  if (currentUser) return !currentUser.email;
  let jwt = getRawCookie(JWT_COOKIE);
  if (!jwt) return true;
  return isTokenAnonymous(jwt);
}
function isTokenAnonymous(jwt) {
  // Decode the jwt payload
  try {
    let payload = JSON.parse(atob(jwt.split('.')[1]));
    return !payload.email;
  } catch(e) {
    // Invalid cookie / coding issue
    // Assume anonymous
    console.error(e, jwt);
    return true;
  }
}

// This must match the value in /services/.../api-token-anonymous/post.json
const FAKE_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1OTI5NDY1MzQsImVtYWlsIjoiIiwib3JpZ19pYXQiOjE1NjE0MTA1MzQsInVzZXJfaWQiOjUyLCJ1c2VybmFtZSI6IjY5ODYyZDQ2MWZiMDRhMWNiZjIxMTNkNjU2ZWJiYTE0In0.nYrZN19nRp_s6dklvbYiFxf6JiOj1SgohYGW31TsRo4";
console.assert(isTokenAnonymous(FAKE_TOKEN));

async function requestToken(token) {
  if (token === FAKE_TOKEN) token = null;
  let method = 'post';
  var url = `${URLS.API}api/v1/auth/api-token-${token?'refresh':'anonymous'}/`;
  if (URLS.STATIC) {
    method = 'get';
    url += 'post.json';
  }
  try {
    var response = await axios[method](url, {token})
  } catch(e) {
    // Token expired, change in environment, or some other issue.
    // If we were refreshing, try again else bubble up the error.
    if (!token) throw e;
    return requestToken()
  }
  setAuthState(response.data);
}

export async function authHeaders() {
  if (!jwtToken) await pending;
  return jwtToken ? {'Authorization': 'Bearer ' + jwtToken} : {};
}

export async function userInfo() {
  if (!currentUser) await pending;
  return currentUser;
}



// WEBPACK FOOTER //
// ./src/services/authorize.js